const root = 'velo-payouts-create';
const TestIds = {
  CLOSE: `${root}-close`,
  SINGLE_PAYOUT: `${root}-single-payout`,
  GROUP_PAYOUT: `${root}-group-payout`,
};

export default TestIds;
